import { InputBase, Stack } from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { FC } from 'react';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';

interface SearchBarProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

export const SearchBar: FC<SearchBarProps> = ({
  placeholder = 'Search',
  value = '',
  onChange,
  disabled,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value);
  };

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        width: '100%',
        border: `1px solid ${abyssColors.primary[200]}`,
        borderRadius: 0,
        padding: '1.2rem 1.6rem',
        gap: '1.6rem',
      }}
    >
      <AbyssIcon iconName="search-simple" size="lg" />
      <InputBase
        placeholder={placeholder}
        value={value}
        onInput={handleChange}
        fullWidth
        disabled={disabled}
        sx={{
          fontSize: '1.2rem',
          color: abyssColors.primary[400],
          '& .MuiInputBase-input': {
            padding: 0,
          },
        }}
      />
    </Stack>
  );
};
